import { ComponentRef, createComponent, inject, EnvironmentInjector, Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { WmsDialogComponent } from '@wms/app/components';
import { forEach, remove } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  public dialogs: any[] = [];
  storeDialogRef: boolean = false;
  openedDialogs: any = [];

  constructor() {}

  getInstanceById(ID: string) {
    return this.dialogs.find(x => x.id === ID);
  }

  // open WmsDialog dynamically with a template
  openWithTemplate(viewContainerRef: ViewContainerRef, injector: EnvironmentInjector, templateRef: TemplateRef<any> | undefined, id: string, customClasses: string) {
    let test = viewContainerRef.createComponent(WmsDialogComponent, {environmentInjector: injector});
    test.instance.id = id;
    test.instance.customClasses = customClasses;
    test.instance.content = templateRef;
    test.instance.showModal();
  }

  showDialog(id: string, params: Object = {}) {
    this.open(id, params);
  }

  closeAllDialogs() {
    forEach(this.openedDialogs.reverse(), (id: string) => {
      this.close(id);
    });
  }

  add(dialog: any) {
      // add dialog to array of active dialogs
      !this.dialogs.find(x => x.id === dialog.id) && this.dialogs.push(dialog);
  }

  remove(id: string) {
      // remove dialog from array of active dialogs
      remove(this.dialogs, (x: any) => x.id === id);
  }

  open(id: string, params?: Object) {
      // open dialog specified by id
      const dialog = this.dialogs.find(x => x.id === id);
      if (dialog) {
        this.openedDialogs.push(dialog.id);
      }
      dialog?.showModal(params);
  }

  close(id: string, destroyInstance?: boolean) {
      // close dialog specified by id
      const dialog = this.dialogs.find(x => x.id === id);
      if (dialog) {
        const dialogIndex = this.openedDialogs.indexOf(dialog.id);
        if (dialogIndex > -1) {
          this.openedDialogs.splice(dialogIndex, 1);
        }
      }
      destroyInstance? dialog?.removeModal() : dialog?.hideModal();
  }
}
